import type { ReactNode } from 'react';

import { useAuthBranding, DEFAULT_AUTH_LOGO } from '../hooks/use-auth-branding';

import { HeroPanel } from './HeroPanel';
import { Logo } from './Logo';

/**
 * Split-screen shell for every auth screen (DEV-3110): left form column (logo +
 * screen content) + right hero panel. The hero collapses on small screens.
 *
 * The screen-specific content owns its title row (and, where Figma shows it,
 * the inline {@link LanguageSwitcher}); this shell only provides the brand
 * logo, the centered 360px column, and the hero.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { logoUrl, isWhiteLabel } = useAuthBranding();

  return (
    <div className="flex min-h-screen gap-6 bg-background p-6">
      {/* Left: form column */}
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="flex w-full max-w-[360px] flex-col gap-6">
          <div className="flex justify-center">
            {isWhiteLabel && logoUrl !== DEFAULT_AUTH_LOGO ? (
              <img src={logoUrl} alt="" className="h-[17px] w-auto" />
            ) : (
              <Logo />
            )}
          </div>
          {children}
        </div>
      </div>

      {/* Right: hero */}
      <HeroPanel />
    </div>
  );
}
